<template>
  <div id="Turnover">
    <loading v-if="loadingRender"></loading>
    <panel
      v-if="wwwtblSarfaslTypeId == 1 && !$GetIsAnbohSaz() == false"
      Title="گردش تسهیلات"
      Des="از طریق این فرم می‌توانید گردش تسهیلات خود را در بازه زمانی دلخواه خود مشاهده کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <panel
      v-else-if="
        wwwtblSarfaslTypeId == 2 ||
        wwwtblSarfaslTypeId == 6 ||
        (wwwtblSarfaslTypeId == 13 && !$GetIsAnbohSaz() == false)
      "
      Title="گردش حساب‌ها"
      Des="از طریق این فرم می‌توانید گردش حساب‌های خود را در بازه زمانی دلخواه خود مشاهده کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <panel
      v-else
      Title="صورت حساب"
      Des="از طریق این فرم می‌توانید گردش حساب‌های خود را در بازه زمانی دلخواه خود مشاهده کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card class="no-print">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-exchange-alt"></i>
          <span v-if="wwwtblSarfaslTypeId == 1 && !$GetIsAnbohSaz() == false"
            >گردش تسهیلات</span
          >
          <span
            v-else-if="
              wwwtblSarfaslTypeId == 2 ||
              wwwtblSarfaslTypeId == 6 ||
              (wwwtblSarfaslTypeId == 13 && !$GetIsAnbohSaz() == false)
            "
            >گردش حساب‌ها</span
          >
          <span v-else>صورت حساب</span>
        </h6>
      </template>
      <template slot="content">
        <div class="netpa-turnover-filters">
          <div class="netpa-turnover-filters__main">
            <div class="netpa-turnover-field netpa-turnover-field--account">
              <label class="netpa-turnover-label" for="cmbTaahodat"
                >انتخاب حساب</label
              >
              <select
                v-if="IsLoad"
                name="cmbTaahodat"
                id="cmbTaahodat"
                class="form-control Pointer netpa-turnover-select"
                v-model="Resultcmb"
              >
                <option v-if="this.IsLoad == false" value="-2">
                  || در حال بارگذاری ، منتظر بمانید ... ||
                </option>
                <option selected value="-1">-- انتخاب حساب --</option>
                <option
                  v-for="item in this.ListModel"
                  :key="item.id"
                  :value="item.id"
                >
                  <span>{{ item.vcodeDesNo }} </span>
                  <span>{{ item.nameFamily }} </span>
                </option>
              </select>
            </div>
            <div
              class="netpa-turnover-daterange"
              :class="{ 'is-disabled': Dahgardesh }"
            >
              <div class="netpa-turnover-field">
                <label class="netpa-turnover-label">از تاریخ</label>
                <date-picker
                  :editable="true"
                  :auto-submit="true"
                  :max="TarikhTa"
                  color="#287db4"
                  v-model="TarikhAz"
                  :disabled="Dahgardesh"
                >
                </date-picker>
                <input
                  type="text"
                  tabindex="-1"
                  class="d-none InputText"
                  style="direction: ltr"
                />
              </div>
              <div class="netpa-turnover-field">
                <label class="netpa-turnover-label">تا تاریخ</label>
                <date-picker
                  :editable="true"
                  :auto-submit="true"
                  :min="TarikhAz"
                  color="#287db4"
                  v-model="TarikhTa"
                  :disabled="Dahgardesh"
                >
                </date-picker>
                <input
                  type="text"
                  tabindex="-1"
                  class="d-none InputText"
                  style="direction: ltr"
                />
              </div>
            </div>
            <div class="netpa-turnover-field netpa-turnover-field--action">
              <span
                class="netpa-turnover-label netpa-turnover-label--spacer"
                aria-hidden="true"
                >&nbsp;</span
              >
              <button
                type="button"
                class="btn btn-success netpa-turnover-search__btn"
                @click="
                  GetGardesh();
                  $ResetTimer();
                "
              >
                <i class="fa fa-search ml-1" aria-hidden="true"></i>
                جستجو
              </button>
            </div>
          </div>
          <div class="netpa-turnover-filters__options">
            <div class="netpa-turnover-switch">
              <span class="netpa-turnover-switch__text">ده گردش آخر</span>
              <div
                class="custom-control custom-switch netpa-turnover-switch__control"
              >
                <input
                  type="checkbox"
                  class="custom-control-input InputText"
                  id="gardesh"
                  :checked="Dahgardesh"
                  @change="DahgardeshChange()"
                  :v-model="Dahgardesh"
                />
                <label class="custom-control-label" for="gardesh">
                  <span class="sr-only">ده گردش آخر</span>
                </label>
              </div>
            </div>
            <div class="netpa-turnover-switch">
              <span class="netpa-turnover-switch__text">تجمیع</span>
              <div
                class="custom-control custom-switch netpa-turnover-switch__control"
              >
                <input
                  type="checkbox"
                  title="تجمیع صورت حساب"
                  class="custom-control-input InputText"
                  id="groupbyGardesh"
                  :checked="groupbyGardesh"
                  @change="groupbyGardeshChange()"
                  :v-model="groupbyGardesh"
                />
                <label class="custom-control-label" for="groupbyGardesh">
                  <span class="sr-only">تجمیع</span>
                </label>
              </div>
            </div>
          </div>
          <div class="d-none">
            <ExcelExport
              :data="exceltable"
              :title="titleExcel"
              :filename="'Turnover_' + $GetJalaliDateTime() + '.xls'"
              worksheet-name="Sheet1"
              @success="handleExcelSuccess"
              @error="handleExcelError"
            >
              <button class="btn btn-outline-success d-none">
                <i
                  class="fas fa-file-excel btn btn-outline-success Pointer d-none"
                  id="DownloadExcel"
                >
                  دانلود فایل اکسل
                </i>
              </button>
            </ExcelExport>
          </div>
        </div>

        <div v-if="Istable" class="netpa-turnover-results">
          <div class="netpa-turnover-cards" dir="rtl">
            <p v-if="!rows.length" class="netpa-turnover-cards__empty">
              موردی برای نمایش وجود ندارد
            </p>
            <template v-else>
            <div class="netpa-turnover-cards__toolbar">
              <input
                v-model="cardSearch"
                type="search"
                class="form-control netpa-turnover-cards__search"
                placeholder=" جستجو"
                aria-label="جستجو در گردش"
              />
              <div class="netpa-turnover-cards__exports" role="group" aria-label="خروجی">
                <button
                  type="button"
                  class="netpa-turnover-export-btn netpa-turnover-export-btn--pdf"
                  title="Pdf"
                  aria-label="دانلود Pdf"
                  @click="GetPDF"
                >
                  <i class="fas fa-file-pdf" aria-hidden="true"></i>
                </button>
                <button
                  type="button"
                  class="netpa-turnover-export-btn netpa-turnover-export-btn--excel"
                  title="Excel"
                  aria-label="دانلود Excel"
                  @click="Download"
                >
                  <i class="fas fa-file-excel" aria-hidden="true"></i>
                </button>
                <button
                  type="button"
                  class="netpa-turnover-export-btn netpa-turnover-export-btn--chart"
                  title="نمودار"
                  aria-label="نمایش نمودار"
                  @click="DrawChart"
                >
                  <i class="fas fa-chart-line" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <p
              v-if="filteredCardRows.length === 0"
              class="netpa-turnover-cards__empty"
            >
              اطلاعاتی یافت نشد
            </p>
            <div v-else class="netpa-turnover-cards__list">
              <article
                v-for="(row, index) in pagedCardRows"
                :key="(row.id || 'row') + '-' + index"
                class="netpa-turnover-card"
                :class="{
                  'netpa-turnover-card--debit': isDebitRow(row),
                  'netpa-turnover-card--credit': !isDebitRow(row),
                }"
              >
                <div class="netpa-turnover-card__header">
                  <span
                    class="netpa-turnover-card__badge"
                    :class="
                      isDebitRow(row)
                        ? 'netpa-turnover-card__badge--debit'
                        : 'netpa-turnover-card__badge--credit'
                    "
                  >
                    <i
                      class="fa"
                      :class="isDebitRow(row) ? 'fa-arrow-up' : 'fa-arrow-down'"
                      aria-hidden="true"
                    ></i>
                    {{ row.amaliyat }}
                  </span>
                  <time class="netpa-turnover-card__date">{{ row.tarix }}</time>
                </div>
                <div
                  v-if="cardPrimaryAmount(row)"
                  class="netpa-turnover-card__amount"
                  :class="
                    isDebitRow(row)
                      ? 'netpa-turnover-card__amount--debit'
                      : 'netpa-turnover-card__amount--credit'
                  "
                >
                  <span dir="ltr">{{ cardPrimaryAmount(row) }}</span>
                  <small>{{ $GetVahedPool() }}</small>
                </div>
                <div class="netpa-turnover-card__fields">
                  <div
                    v-if="hasMoney(row.bestan) && !cardPrimaryAmount(row)"
                    class="netpa-turnover-card__field"
                  >
                    <span class="netpa-turnover-card__label">واریز</span>
                    <span class="netpa-turnover-card__value netpa-turnover-card__value--credit" dir="ltr">
                      {{ row.bestan }}
                    </span>
                  </div>
                  <div
                    v-if="hasMoney(row.bedeh) && !cardPrimaryAmount(row)"
                    class="netpa-turnover-card__field"
                  >
                    <span class="netpa-turnover-card__label">برداشت</span>
                    <span class="netpa-turnover-card__value netpa-turnover-card__value--debit" dir="ltr">
                      {{ row.bedeh }}
                    </span>
                  </div>
                  <div class="netpa-turnover-card__field">
                    <span class="netpa-turnover-card__label">مانده</span>
                    <span class="netpa-turnover-card__value" dir="ltr">
                      {{ row.mande }}
                    </span>
                  </div>
                  <div
                    v-if="showSharhColumn && row.sharh"
                    class="netpa-turnover-card__field"
                  >
                    <span class="netpa-turnover-card__label">شرح سند</span>
                    <span class="netpa-turnover-card__value netpa-turnover-card__value--sharh">
                      <i
                        v-if="row.sharh !== ''"
                        class="fas fa-credit-card text-warning"
                        aria-hidden="true"
                      ></i>
                      {{ row.sharh }}
                    </span>
                  </div>
                  <div v-if="row.orderId" class="netpa-turnover-card__field">
                    <span class="netpa-turnover-card__label">شماره سفارش</span>
                    <span class="netpa-turnover-card__value" dir="ltr">
                      {{ row.orderId }}
                    </span>
                  </div>
                </div>
                <div class="netpa-turnover-card__actions">
                  <button
                    type="button"
                    class="netpa-turnover-card__receipt"
                    @click="Recipt(row)"
                  >
                    <i class="fas fa-download" aria-hidden="true"></i>
                    دانلود رسید
                  </button>
                </div>
              </article>
            </div>
            <div
              v-if="filteredCardRows.length > cardPerPage"
              class="netpa-turnover-cards__pager"
            >
              <button
                type="button"
                class="netpa-turnover-cards__pager-btn"
                :disabled="cardPage <= 1"
                @click="cardPage = cardPage - 1"
              >
                قبلی
              </button>
              <span class="netpa-turnover-cards__pager-info">
                صفحه {{ cardPage }} از {{ cardPageCount }}
              </span>
              <button
                type="button"
                class="netpa-turnover-cards__pager-btn"
                :disabled="cardPage >= cardPageCount"
                @click="cardPage = cardPage + 1"
              >
                بعدی
              </button>
            </div>
            </template>
          </div>
          <div class="netpa-turnover-table-view">
            <vue-bootstrap4-table
              :rows="rows"
              :columns="columns"
              :config="config"
              :classes="classes"
              :actions="actions"
              @on-download="Download"
              @on-chart="DrawChart"
              @on-download-pdf="GetPDF"
            >
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="sharh" slot-scope="props">
                <i
                  class="fas fa-credit-card text-warning px-2"
                  style="font-size: 16px"
                  v-if="props.cell_value != ''"
                ></i>
                {{ props.cell_value }}
              </template>
              <template slot="reciept" slot-scope="props">
                <a @click="Recipt(props.row)" class="Pointer">
                  <i class="fas fa-download text-secondary"></i
                ></a>
                {{ props.cell_value }}
              </template>
              <template slot="amaliyat" slot-scope="props">
                <div v-if="wwwtblSarfaslTypeId == 1">
                  <small
                    v-if="props.cell_value == 'دريافت تسهيلات'"
                    class="text-danger"
                  >
                    <i class="fa fa-arrow-up"></i>
                    {{ props.cell_value }}
                  </small>
                  <small v-else class="text-success">
                    <i class="fa fa-arrow-down"></i>
                    {{ props.cell_value }}
                  </small>
                </div>
                <div v-else>
                  <small v-if="props.cell_value == 'برداشت'" class="text-danger">
                    <i class="fa fa-arrow-up"></i>
                    {{ props.cell_value }}
                  </small>
                  <small v-else class="text-success">
                    <i class="fa fa-arrow-down"></i>
                    {{ props.cell_value }}
                  </small>
                </div>
              </template>
              <template slot="Action" slot-scope="props">
                <button
                  @click="RemoveBedeh(props.row)"
                  v-if="
                    props.row.bedeh.replace(/,/g, '').replace(/\./g, '') > 0 &&
                    (props.row.bnpCashDBtblSanadRizId == 0 ||
                      props.row.bnpCashDBtblSanadRizId == null)
                  "
                  class="btn btn-danger"
                >
                  <i class="fas fa-trash ml-2"></i> حذف درخواست برداشت
                </button>
                <span v-else>تراکنش ثبت سند شده است</span>
              </template>
            </vue-bootstrap4-table>
          </div>
        </div>
        <div v-else dir="ltr">
          <button
            @click="DrawChart"
            class="btn btn-outline-success netpa-turnover-table-btn"
          >
            <i class="fas fa-table"></i>
          </button>
          <apexchart
            type="area"
            height="350"
            :options="chartOptions"
            :series="series"
          ></apexchart>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import loading from "../Tools/NetPa/Loading.vue";
import html2pdf from "html2pdf.js";
export default {
  data() {
    return {
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "Gardesh_Taahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      ListModel: null,
      ListModelSahebHesab: null,
      IsLoad: false,
      TarikhAz: "",
      TarikhTa: "",
      exceltable: [],
      Resultcmb: null,
      Istable: true,
      rows: [],
      titleExcel: "",
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },

        {
          label: "شرح سند",
          name: "sharh",
          column_classes: "sharhSand",
          row_classes: "sharhSand",
          visibility: this.$session.get("CustCode") == 868 ? false : true,
        },
        {
          label: "تاریخ تراکنش",
          name: "tarix",
          sort: true, // "false" by default
          initial_sort: true, // "false" by default
          initial_sort_order: "desc",
        },
        {
          label: "شماره سفارش",
          name: "orderId",
        },
        {
          label: "تراکنش",
          name: "amaliyat",
        },
        {
          label: "واریز",
          name: "bestan",
        },
        {
          label: "برداشت",
          name: "bedeh",
        },
        {
          label: "مانده",
          name: "mande",
        },
        {
          label: "رسید",
          name: "reciept",
        },
        // {
        //   label: 'عملیات',
        //   name: 'Action',
        // },
      ],
      actions: [
        {
          btn_text: "Pdf",
          event_name: "on-download-pdf",
          class: "btn btn-secondary rounded btnEXL ",
          event_payload: {
            msg: "my custom msg",
          },
        },
        {
          btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
          event_name: "on-download",
          class: "btn  mx-2 btn-outline-success rounded btnEXL ",
          event_payload: {
            msg: "my custom msg",
          },
        },
        {
          btn_text: "<i style='font-size:15px' class='fas fa-chart-line '>",
          event_name: "on-chart",
          class: "btn  btn-outline-danger rounded",
          event_payload: {
            msg: "my custom msg",
          },
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page: 100,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      series: [
        {
          name: "",
          data: [],
        },
        {
          name: "",
          data: [],
        },
        {
          name: "",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "area",

          dataLabels: {
            enabled: true,
          },
          stroke: {
            curve: "smooth",
          },
          toolbar: {
            autoSelected: "zoom",
          },
        },
        dataLabels: {
          enabled: false,
        },

        title: {
          text: "",
          align: "",
        },
        colors: ["#2A3F54", "#435ebe", "#ff5000"],
        yaxis: {
          title: {
            text: "موجودی",
          },
        },
        xaxis: {
          type: "string",
          categories: [],
        },
        tooltip: {
          shared: false,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },

        markers: {
          size: 1,
        },
      },
      loadingRender: false,
      Dahgardesh: false,
      groupbyGardesh: false,
      cardSearch: "",
      cardPage: 1,
      cardPerPage: 10,
    };
  },
  computed: {
    showSharhColumn() {
      return this.$session.get("CustCode") != 868;
    },
    filteredCardRows() {
      const q = (this.cardSearch || "").trim().toLowerCase();
      if (!q) return this.rows;
      return this.rows.filter((row) => {
        const hay = [
          row.sharh,
          row.tarix,
          row.orderId,
          row.amaliyat,
          row.bestan,
          row.bedeh,
          row.mande,
        ]
          .filter((v) => v != null && v !== "")
          .join(" ")
          .toLowerCase();
        return hay.includes(q);
      });
    },
    pagedCardRows() {
      const start = (this.cardPage - 1) * this.cardPerPage;
      return this.filteredCardRows.slice(start, start + this.cardPerPage);
    },
    cardPageCount() {
      return Math.max(
        1,
        Math.ceil(this.filteredCardRows.length / this.cardPerPage),
      );
    },
  },
  watch: {
    rows() {
      this.cardPage = 1;
    },
    cardSearch() {
      this.cardPage = 1;
    },
  },
  mounted() {
    this.$AutoCloseMenuForMobile();

    const formData = new FormData();
    let info;
    formData.append(
      "wwwtblAzaId",
      this.$session.get("UserInfoNetPa").wwwtblAzaId,
    );
    formData.append(
      "wwwtblSarfaslTypeId",
      this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId,
    );
    this.DataAxios_cmbTaahodat.ArryfildValue = formData;
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true;
        this.ListModel = data;
        this.Resultcmb =
          this.TaahodatId == undefined ? data[0].id : this.TaahodatId;
      })
      .finally(() => {
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append(
          "wwwtblSarfaslTypeId",
          this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId,
        );
        this.DataAxios_SahebHesab.ArryfildValue = formData;
        this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
          if (data.length > 0) {
            this.IsLoad = true;
            this.ListModelSahebHesab = data;
            for (
              let index = 0;
              index < this.ListModelSahebHesab.length;
              index++
            ) {
              info = this.ListModelSahebHesab[index];
              this.ListModel.push(info);
            }
          }
        });
      });
  },
  components: {
    VueBootstrap4Table,
    Panel,
    NetPaCard,
    loading,
  },

  methods: {
    handleExcelSuccess(message) {
      this.$mySweetDefaultTost("موفق", message, "success", 2000);
    },
    handleExcelError(message) {
      this.$mySweetDefaultTost("خطا", message, "error", 2000);
    },
    RemoveBedeh(row) {
      this.$mySweetDefaultTost(
        "درحال بررسی",
        "درحال بررسی حذف درخواست برداشت از حساب ، لطفا منتظر بمانید",
        "info",
      );
      var DataAxios_Data = {
        ArryfildValue: "",
        Method: "Post",
        Action: "Gardesh_Taahodat/RemoveBardasht",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtblGardeshId", row.id);
      formData.append("Mablagh", row.bedeh.replace(/,/g, ""));
      formData.append("wwwtblEnteghal", row.wwwtblEnteghalId);
      DataAxios_Data.ArryfildValue = formData;

      this.$PostFormData(DataAxios_Data).then((data) => {
        if (data.status == "Ok") {
          this.$mySweetDefaultTost(
            "حذف موفق",
            " حذف درخواست برداشت از حساب مورد نظر با موفقیت انجام شد",
            "success",
            4000,
          );
          this.GetGardesh();
        }
      });
    },
    DahgardeshChange() {
      if (this.Dahgardesh) {
        this.Dahgardesh = false;
      } else {
        this.Dahgardesh = true;
        this.TarikhAz = "";
        this.TarikhTa = "";
        this.groupbyGardesh = false;
      }
    },
    groupbyGardeshChange() {
      if (this.groupbyGardesh) {
        this.groupbyGardesh = false;
      } else {
        this.groupbyGardesh = true;
        this.Dahgardesh = false;
      }
    },
    Recipt(data) {
      this.loadingRender = true;
      var DataAxios_Data = {
        ArryfildValue: "",
        Method: "Post",
        Action: "Gardesh_Taahodat/GardeshDetail",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtblEnteghalId", data.wwwtblEnteghalId);
      DataAxios_Data.ArryfildValue = formData;

      this.$PostFormData(DataAxios_Data)
        .then((res) => {
          this.loadingRender = false;
          if (res.status == true) {
            if (res.data.length == 2) {
              var htmls = `
              <div class=" container-f textblack p-4" dir="rtl">
                <div class="containerbackground ">رسید عملیات مالی </div>
                <div class="row">
                  <div class="col-3"></div>
                  <div class="col-6 text-center">
                    <h4>رسید تراکنش </h4>
                    <h6>${this.$session.get("NameSandogh")}</h6>
                  </div>
                  <div class="col-3 text-center" >
                  </div>
                </div>
                <div class="row textblack">
                  <div class="col-6 text-right">
                    <p>تاریخ صدور:${this.$GetJalaliDate()}</p>
                 </div>
                  <div class="col-6 text-left">
                   <p> کد پیگیری : ${res.data[0].coderahgiri} </p>
                  </div>
                </div>
              </div>
              <div class="row textblack border p-3 mt-2 mx-4">
                <div class="container">
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">نوع عملیات:</div>
                    <div class="col-6 text-right text-info">
                      ${
                        res.data[0].wwwTaahodatId > 0 &&
                        res.data[1].wwwTaahodatId > 0
                          ? "انتقال وجه داخلی"
                          : "انتقال وجه"
                      }
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مشخصات حساب مبدا</div>
                    <div class="col-6 ">
                      ${
                        res.data[0].fullname
                      }  <span dir="ltr" class="float-right"> ${
                res.data[0].vCode
              }</span>
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مشخصات حساب مقصد</div>
                    <div class="col-6">
                       ${
                         res.data[1].fullname
                       }  <span dir="ltr" class="float-right"> ${
                res.data[1].vCode
              }</span>
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مبلغ:</div>
                    <div class="col-6 text-right">
                      ${data["mablagh"]}  ${this.$GetVahedPool()}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">تاریخ تراکنش:</div>
                    <div class="col-6 text-right">
                      ${data["tarix"]}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right"> شماره سفارش:</div>
                    <div class="col-6 text-right">
                      ${data["orderId"]}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">ساعت تراکنش:</div>
                    <div class="col-6 text-right">
                      ${res.data[0].zamanInsert}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">شرح وضعیت:</div>
                    <div class="col-6 text-right">
                      ${data["sharh"]}

                    </div>
                  </div>
                </div>
              </div>
                  <div class="row">
                  <div class="col-12 text-center textblack">
                      <hr>
                      <span style="font-size: x-small;">
                          طراحی و پیاده سازی شرکت پاسارگاد
                      </span>
                      </br>
                      <img style="height:10% !important" src="/img/icons/apple-touch-icon-180x180.png">
                      </br>
                      <span style="font-size: x-small;">
                          www.bnpco.ir
                      </span>

              </div>
              </div>`;
            }
            if (res.data.length == 1) {
              var htmls = `
              <div class=" container-f textblack p-4" dir="rtl">
                <div class="containerbackground ">رسید عملیات مالی </div>
                <div class="row">
                  <div class="col-3"></div>
                  <div class="col-6 text-center">
                    <h4>رسید تراکنش </h4>
                    <h6>${this.$session.get("NameSandogh")}</h6>
                  </div>
                  <div class="col-3 text-center" >
                  </div>
                </div>
                <div class="row textblack mt-2">
                  <div class="col-6 text-right">
                    <p>تاریخ صدور:${this.$GetJalaliDate()}</p>
                 </div>
                  <div class="col-6 text-left">
                   <p> کد پیگیری : ${res.data[0].coderahgiri} </p>
                  </div>
                </div>
              </div>
              <div class="row textblack border p-3 mx-4">
                <div class="container">
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">نوع عملیات:</div>
                    <div class="col-6 text-right ${
                      data.amaliyat == "برداشت" ? "text-danger" : "text-success"
                    }">
                      ${data.amaliyat}
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مشخصات حساب مبدا</div>
                    <div class="col-6 ">
                      ${
                        data.amaliyat == "برداشت" ? res.data[0].fullname : ""
                      }  <span dir="ltr" class="float-right"> ${
                data.amaliyat == "برداشت" ? res.data[0].vCode : "-"
              }</span>
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مشخصات حساب مقصد</div>
                    <div class="col-6">
                         <span dir="ltr" class="float-right"> ${
                           data.amaliyat == "برداشت"
                             ? res.data[0].cardNo == null
                               ? res.data[0].shebaNo +
                                 " : شبا " +
                                 " " +
                                 res.data[0].sahebHesab
                               : res.data[0].cardNo.match(/.{1,4}/g).join("-") +
                                 " : کارت " +
                                 " " +
                                 res.data[0].sahebHesab
                             : res.data[0].vCode + " - " + res.data[0].fullname
                         }</span>
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مبلغ:</div>
                    <div class="col-6 text-right">
                      ${data["mablagh"]}  ${this.$GetVahedPool()}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">تاریخ تراکنش:</div>
                    <div class="col-6 text-right">
                      ${data["tarix"]}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">ساعت تراکنش:</div>
                    <div class="col-6 text-right">
                      ${res.data[0].zamanInsert}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">شرح وضعیت:</div>
                    <div class="col-6 text-right">
                      ${data["sharh"]}

                    </div>
                  </div>
                </div>
              </div>
                  <div class="row">
                  <div class="col-12 text-center textblack">
                      <hr>
                      <span style="font-size: x-small;">
                          طراحی و پیاده سازی شرکت پاسارگاد
                      </span>
                      </br>
                      <img style="height:10% !important" src="/img/icons/apple-touch-icon-180x180.png">
                      </br>
                      <span style="font-size: x-small;">
                          www.bnpco.ir
                      </span>

              </div>
              </div>`;
            }
            var htmlObject = document.createElement("div");
            htmlObject.innerHTML = htmls;
            html2pdf(htmlObject, {
              jsPDF: { format: "a5" },
            });
          } else {
            //this.$mySweetDefaultTost('خطا', res.message, 'warning', 4000)

            var htmls = `
    <div class=" container-f textblack p-4" dir="rtl">
      <div class="containerbackground ">رسید عملیات مالی </div>
      <div class="row">
        <div class="col-3"></div>
        <div class="col-6 text-center">
          <h4>رسید تراکنش </h4>
          <h6>${this.$session.get("NameSandogh")}</h6>
        </div>
        <div class="col-3 text-center" >
        </div>
      </div>
      <div class="row textblack">
        <div class="col-12 text-right">
          <p>تاریخ صدور:${this.$GetJalaliDate()}</p>

        </div>

      </div>
    </div>
    <div class="row textblack border p-3 mt-2 mx-4">
      <div class="container">
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">نوع عملیات:</div>
          <div class="col-6 text-right">
             ${data["amaliyat"]}
          </div>
        </div>
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">مشخصات حساب</div>
          <div class="col-6 text-right">
             ${data["desNoe"]} -- <span dir="ltr"> ${data["vCode"]}</span>

          </div>
        </div>
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">مبلغ:</div>
          <div class="col-6 text-right">
             ${data["mablagh"]}  ${this.$GetVahedPool()}

          </div>
        </div>
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">تاریخ تراکنش:</div>
          <div class="col-6 text-right">
             ${data["tarix"]}

          </div>
        </div>
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">شرح وضعیت:</div>
          <div class="col-6 text-right">
             ${data["sharh"]}

          </div>
        </div>
      </div>
    </div>
        <div class="row">
        <div class="col-12 text-center textblack">
            <hr>
            <span style="font-size: x-small;">
                طراحی و پیاده سازی شرکت پاسارگاد
            </span>
            </br>
            <img style="height:10% !important" src="/img/icons/apple-touch-icon-180x180.png">
            </br>
            <span style="font-size: x-small;">
                www.bnpco.ir
            </span>

    </div>
    </div>`;

            var htmlObject = document.createElement("div");
            htmlObject.innerHTML = htmls;
            html2pdf(htmlObject, {
              jsPDF: { format: "a5" },
            });
          }
        })
        .catch(function (err) {
          console.error(err);
        });

      // <img style="max-width:100% !important" src="${this.$cookies.get('URL') + 'PDF/logo.png'}" alt="${this.$session.get('NameSandogh')}">
    },
    Download() {
      document.getElementById("DownloadExcel").click();
    },
    exelReport(rows) {
      ///console.log('Reeeeeeeeport', rows);
      this.exceltable = [];
      const accountNumber = " " + rows[0].vCode;
      const selectedAccount = (this.ListModel || []).find(
        (item) => item.id == this.Resultcmb,
      );
      const ownerName =
        selectedAccount && selectedAccount.nameFamily
          ? selectedAccount.nameFamily
          : "";
      this.titleExcel =
        "گردش حساب مربوط به حساب " +
        rows[0].desNoe +
        " " +
        accountNumber +
        (ownerName ? " به نام " + ownerName : "") +
        " از تاریخ : " +
        this.TarikhAz +
        " تا تاریخ : " +
        this.TarikhTa;

      rows.forEach((element) => {
        var excelrow = {
          "شماره حساب": element.vCode,
          "شرح سند": element.sharh,
          تراکنش: element.amaliyat,
          واریز: element.bestan,
          برداشت: element.bedeh,
          موجودی: element.mande,
          تاریخ: element.tarix,
          " شماره سفارش": element.orderId,
        };

        this.exceltable.push(excelrow);
      });
      // console.log( this.exceltable);
    },
    parseMablaghNumber(value) {
      return typeof value === "number"
        ? value
        : parseInt(String(value).replace(/,/g, "")) || 0;
    },
    hasMoney(value) {
      return this.parseMablaghNumber(value) > 0;
    },
    isDebitRow(row) {
      if (!row) return false;
      if (this.wwwtblSarfaslTypeId == 1) {
        return row.amaliyat == "دريافت تسهيلات";
      }
      return row.amaliyat == "برداشت";
    },
    cardPrimaryAmount(row) {
      const hasBedeh = this.hasMoney(row.bedeh);
      const hasBestan = this.hasMoney(row.bestan);
      if (hasBedeh && hasBestan) return "";
      if (hasBedeh) return row.bedeh;
      if (hasBestan) return row.bestan;
      return "";
    },
    groupByTarixWithFixedSharh(data) {
      data.sort((a, b) => a.zamanInsert.localeCompare(b.zamanInsert));

      const counts = data.reduce((acc, item) => {
        acc[item.tarix] = (acc[item.tarix] || 0) + 1;
        return acc;
      }, {});

      const grouped = {};
      const result = [];

      for (const item of data) {
        const date = item.tarix;

        if (counts[date] > 1) {
          if (!grouped[date]) {
            grouped[date] = {
              id: item.id,
              wwwtblAzaId: item.wwwtblAzaId,
              vCode: item.vCode,
              tarix: date,
              sharh: "صورت حساب تجمیع شده",
              amaliyat: item.amaliyat,
              amaliyatInt: item.amaliyatInt,
              desNoe: item.desNoe,
              desTaahod: item.desTaahod,
              bedeh: 0,
              bestan: 0,
              mandeAzGhabl: item.mandeAzGhabl,
              shomareSanad: item.shomareSanad,
              zamanInsert: item.zamanInsert,
              bnpCashDBtblSanadRizId: item.bnpCashDBtblSanadRizId,
              wwwtblEnteghalId: item.wwwtblEnteghalId,
              isMovaghat: item.isMovaghat,
              mablagh: item.mablagh,
              mande: 0,
              terminalId: item.terminalId,
              orderId: item.orderId,
            };
          }

          const bedeh = item.bedeh;
          const bestan = item.bestan;

          grouped[date].bedeh += bedeh;
          grouped[date].bestan += bestan;

          grouped[date].mande = this.parseMablaghNumber(item.mande);
        } else {
          result.push({
            id: item.id,
            wwwtblAzaId: item.wwwtblAzaId,
            vCode: item.vCode,
            tarix: date,
            sharh: item.sharh,
            amaliyat: item.amaliyat,
            amaliyatInt: item.amaliyatInt,
            desNoe: item.desNoe,
            desTaahod: item.desTaahod,
            bedeh: item.bedeh,
            bestan: item.bestan,
            mandeAzGhabl: item.mandeAzGhabl,
            shomareSanad: item.shomareSanad,
            zamanInsert: item.zamanInsert,
            bnpCashDBtblSanadRizId: item.bnpCashDBtblSanadRizId,
            wwwtblEnteghalId: item.wwwtblEnteghalId,
            isMovaghat: item.isMovaghat,
            mablagh: item.mablagh,
            mande: this.parseMablaghNumber(item.mande),
            terminalId: item.terminalId,
            orderId: item.orderId,
          });
        }
      }

      const finalResult = [...result, ...Object.values(grouped)];
      finalResult.sort((a, b) => b.tarix.localeCompare(a.tarix));

      return finalResult;
    },
    applyGardeshData(data) {
      if (!data.length) {
        this.$mySweetDefaultTost(
          "عدم وجود اطلاعات",
          "تراکنشی یافت نشد ، فیلتر جستجوی خود را تغییر دهید",
          "warning",
          2000,
        );
        this.config.pagination = false;
        this.rows = [];
        return;
      }

      if (this.groupbyGardesh) {
        data = this.groupByTarixWithFixedSharh(data);
      }

      let info;
      let list = [];
      if (this.Dahgardesh == true && data.length > 10) {
        for (let index = 0; index < 10; index++) {
          info = data[index];
          list.push(info);
        }
      } else {
        this.config.pagination = data.length > 10;
        for (let index = 0; index < data.length; index++) {
          info = data[index];
          list.push(info);
        }
      }

      this.rows = this.$FormatMablaghGrid(list);
      this.exelReport(this.rows);

      this.series = [
        { name: "", data: [] },
        { name: "", data: [] },
        { name: "", data: [] },
      ];
      this.chartOptions.xaxis.categories = [];

      for (let index = list.length - 1; index >= 0; index--) {
        const element = data[index];
        const mandeVal =
          typeof element.mande === "number"
            ? element.mande
            : Number(String(element.mande).replace(/,/g, ""));
        const bestanVal =
          typeof element.bestan === "number"
            ? element.bestan
            : Number(String(element.bestan).replace(/,/g, ""));
        const bedehVal =
          typeof element.bedeh === "number"
            ? element.bedeh
            : Number(String(element.bedeh).replace(/,/g, ""));

        this.chartOptions.xaxis.categories.push(element.tarix);
        this.series[0].name = "مانده";
        this.series[0].data.push(mandeVal);
        this.series[1].name = "واریز";
        this.series[1].data.push(bestanVal);
        this.series[2].name = "برداشت";
        this.series[2].data.push(bedehVal);
      }
    },
    GetGardesh() {
      if (this.Resultcmb == null || this.Resultcmb == -1) {
        this.$mySweetDefaultTost(
          "خطا",
          "لطفا یک حساب انتخاب کنید",
          "warning",
          2000,
        );
        this.rows = [];
        return;
      }

      this.loadingRender = true;
      const formData = new FormData();
      formData.append("wwwtblTaahodatId", this.Resultcmb);
      formData.append("AzTarix", this.TarikhAz == null ? "" : this.TarikhAz);
      formData.append("TaTarix", this.TarikhTa == null ? "" : this.TarikhTa);
      formData.append("TerminalIdInput", "");
      this.DataAxiosRow.ArryfildValue = formData;
      console.log("************", formData);
      console.log("wwwtblTaahodatId: ", this.Resultcmb);
      console.log("AzTarix: ", this.TarikhAz);
      console.log("TaTarix: ", this.TarikhTa);
      this.$PostFormData(this.DataAxiosRow)
        .then((data) => {
          console.log("data___", data);
          this.applyGardeshData(data);
        })
        .finally(() => {
          this.loadingRender = false;
        });
    },
    DrawChart() {
      this.Istable = !this.Istable;
    },
    GetPDF() {
      if (this.rows.length > 0) {
        this.$router.push({
          name: "TurnoverPDF",
          params: { Rows: this.rows, Taahod: find },
        });
      }
    },
  },
  props: [
    "TaahodatId",
    "wwwtblSarfaslTypeId",
    "wwwtblAzaId",
    "wwwtblAzaIdAccount",
  ],
  created() {
    if (this.wwwtblAzaId) {
      this.$session.set("UserFromLoan", [this.wwwtblAzaId, false]);
    }
    if (this.wwwtblAzaIdAccount) {
      this.$session.set("UserFromAccount", [this.wwwtblAzaIdAccount, false]);
    }
  },
};
</script>
<style>
.sharhSand {
  text-align: right !important;
}

.btn-group {
  float: left !important;
}
.container-f {
  position: relative !important;
}

.containerbackground {
  margin: 3rem;
  position: absolute;
  top: 200px;
  left: 100px;
  z-index: -1;
  transform: rotate(-20deg);
  -webkit-transform: rotate(-20deg);
  color: #abe4f871;
  font-size: 40px;
}
.textblack {
  color: rgb(70, 70, 70) !important;
  border-color: rgb(70, 70, 70) !important;
  border-radius: 10px !important;
  padding: 2% !important;
}

#Turnover .netpa-turnover-filters {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  width: 100%;
  margin: 0 0 1rem;
  padding: 0 0 1rem;
  border-bottom: 1px solid #e8eef2;
}

#Turnover .netpa-turnover-filters__main {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem;
}

#Turnover .netpa-turnover-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
  text-align: right;
}

#Turnover .netpa-turnover-field--account {
  flex: 1 1 15rem;
  max-width: 18rem;
}

#Turnover .netpa-turnover-daterange {
  display: flex;
  flex: 1 1 16rem;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 0.75rem;
  max-width: 22rem;
}

#Turnover .netpa-turnover-daterange .netpa-turnover-field {
  flex: 1 1 0;
  min-width: 0;
}

#Turnover .netpa-turnover-field--action {
  flex: 0 0 auto;
}

#Turnover .netpa-turnover-label {
  display: block;
  margin-bottom: 0.35rem;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.25;
}

#Turnover .netpa-turnover-label--spacer {
  visibility: hidden;
  user-select: none;
}

#Turnover .netpa-turnover-select,
#Turnover .netpa-turnover-search__btn {
  height: 40px;
  min-height: 40px;
  box-sizing: border-box;
}

#Turnover .netpa-turnover-select {
  width: 100%;
  padding: 0.4rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  line-height: 1.2;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
}

#Turnover .netpa-turnover-select:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#Turnover .netpa-turnover-daterange .vpd-main {
  display: block;
  width: 100%;
}

#Turnover .netpa-turnover-daterange .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

#Turnover .netpa-turnover-daterange .vpd-input-group:focus-within {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#Turnover .netpa-turnover-daterange .vpd-input-group input,
#Turnover .netpa-turnover-daterange .vpd-input-group input.form-control {
  width: 100%;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.65rem;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
}

#Turnover .netpa-turnover-daterange .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.2rem;
  margin: 0 !important;
  padding: 0 0.5rem !important;
  color: #287db4;
  border: none;
  background: #edf5fb;
}

#Turnover .netpa-turnover-daterange.is-disabled {
  opacity: 0.55;
  pointer-events: none;
}

#Turnover .netpa-turnover-search__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 6.75rem;
  margin: 0;
  padding: 0 1rem;
  border-radius: 12px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
}

#Turnover .netpa-turnover-filters__options {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 1.25rem;
}

#Turnover .netpa-turnover-switch {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 32px;
}

#Turnover .netpa-turnover-switch__text {
  color: #6b7b8e;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
}

#Turnover .netpa-turnover-switch__control {
  position: relative;
  flex: 0 0 2.25rem;
  width: 2.25rem;
  min-height: 1.5rem;
  padding: 0 !important;
  margin: 0;
}

#Turnover .netpa-turnover-switch__control .custom-control-label {
  width: 2.25rem;
  height: 1.5rem;
  margin: 0;
  padding: 0;
  font-size: 0;
  line-height: 0;
}

#Turnover .netpa-turnover-switch__control .custom-control-label::before {
  left: 0 !important;
  right: auto !important;
  top: 0.125rem;
}

#Turnover .netpa-turnover-switch__control .custom-control-label::after {
  left: 2px !important;
  right: auto !important;
  top: calc(0.125rem + 2px);
}

#Turnover .netpa-turnover-table-btn {
  border-radius: 12px !important;
  corner-shape: squircle;
}

#Turnover .netpa-turnover-cards {
  display: none;
}

#Turnover .netpa-turnover-cards__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin: 0 0 0.85rem;
}

#Turnover .netpa-turnover-cards__search {
  flex: 1 1 12rem;
  min-width: 0;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dce1e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(42, 63, 84, 0.06);
}

#Turnover .netpa-turnover-cards__search:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

#Turnover .netpa-turnover-cards__exports {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-inline-start: auto;
}

#Turnover .netpa-turnover-export-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  cursor: pointer;
}

#Turnover .netpa-turnover-export-btn--pdf {
  color: #b44f46;
  border-color: #f0d6d3;
  background: #fdf6f5;
}

#Turnover .netpa-turnover-export-btn--excel {
  color: #1f8a4c;
  border-color: #cfe8d8;
  background: #f3faf6;
}

#Turnover .netpa-turnover-export-btn--chart {
  color: #287db4;
  border-color: #d5e8f3;
  background: #f3f8fc;
}

#Turnover .netpa-turnover-cards__empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

#Turnover .netpa-turnover-cards__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

#Turnover .netpa-turnover-card {
  padding: 0.95rem 1rem 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

#Turnover .netpa-turnover-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  margin-bottom: 0.65rem;
}

#Turnover .netpa-turnover-card__badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-height: 28px;
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

#Turnover .netpa-turnover-card__badge--credit {
  color: #1f8a4c;
  background: #eef8f2;
}

#Turnover .netpa-turnover-card__badge--debit {
  color: #b44f46;
  background: #fdf3f2;
}

#Turnover .netpa-turnover-card__date {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

#Turnover .netpa-turnover-card__amount {
  margin: 0 0 0.75rem;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.3;
}

#Turnover .netpa-turnover-card__amount small {
  margin-right: 0.3rem;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

#Turnover .netpa-turnover-card__amount--credit {
  color: #1f8a4c;
}

#Turnover .netpa-turnover-card__amount--debit {
  color: #b44f46;
}

#Turnover .netpa-turnover-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-bottom: 0.75rem;
}

#Turnover .netpa-turnover-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

#Turnover .netpa-turnover-card__label {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

#Turnover .netpa-turnover-card__value {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  word-break: break-word;
}

#Turnover .netpa-turnover-card__value--credit {
  color: #1f8a4c;
}

#Turnover .netpa-turnover-card__value--debit {
  color: #b44f46;
}

#Turnover .netpa-turnover-card__value--sharh {
  display: inline-flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 0.35rem;
  text-align: right;
}

#Turnover .netpa-turnover-card__actions {
  display: flex;
  justify-content: flex-end;
}

#Turnover .netpa-turnover-card__receipt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 34px;
  padding: 0.3rem 0.8rem;
  color: #287db4;
  border: 1px solid #d5e8f3;
  border-radius: 10px;
  background: #f3f8fc;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

#Turnover .netpa-turnover-cards__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.85rem;
}

#Turnover .netpa-turnover-cards__pager-btn {
  min-height: 34px;
  padding: 0.3rem 0.85rem;
  color: #29345f;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

#Turnover .netpa-turnover-cards__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

#Turnover .netpa-turnover-cards__pager-info {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

@media (max-width: 767px) {
  #Turnover .netpa-turnover-field--account,
  #Turnover .netpa-turnover-daterange,
  #Turnover .netpa-turnover-field--action {
    flex: 1 1 100%;
    max-width: 100%;
  }

  #Turnover .netpa-turnover-search__btn {
    width: 100%;
  }

  #Turnover .netpa-turnover-filters__options {
    justify-content: space-between;
  }

  #Turnover .netpa-turnover-cards {
    display: block;
  }

  #Turnover .netpa-turnover-table-view {
    display: none;
  }
}
</style>
